<template>
  <div id="app" class="victoria-app" :class="appThemeClass">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  computed: {
    appThemeClass() {
      return this.$route && ['login', 'register'].includes(this.$route.name)
        ? 'victoria-auth-theme'
        : 'victoria-inner-theme'
    }
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token') && this.$route.path !== '/Login'){
          this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }

  },
  created(){
    this.getBaseInfo();
  }
}
</script>

<style>
body .van-toast {
  font-size: 0.35rem;
  padding: 0.24rem;
  line-height: .5rem;
  width: 100%;
}
body .van-toast .van-toast__icon {
  font-size: 0.8rem;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
